"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var $ = require("jquery");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var metrikaUtils_1 = require("../../app/utils/metrikaUtils");
var AddToContactButtonComponent = (function (_super) {
    __extends(AddToContactButtonComponent, _super);
    function AddToContactButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.libraryId = ko.observable();
        this.isActive = ko.pureComputed(function () {
            return !!_this.libraryId();
        });
        this.libraryId(params.libraryId);
        this.workId = params.workId;
        if (params.isMobile) {
            $(element).find("span").removeAttr("style");
        }
    }
    AddToContactButtonComponent.prototype.toggle = function () {
        var _this = this;
        if (!app.ensureAuth("Чтобы добавить книгу в библиотеку, необходимо авторизоваться")) {
            return;
        }
        if (this.processing())
            return;
        this.processing(true);
        if (this.isActive()) {
            ajaxUtils_1.AjaxUtils.post("work/removeFromLibrary", { id: this.libraryId() })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.libraryId(null);
            })
                .always(function () {
                _this.processing(false);
                _this.handleRefreshWorkMetaInfo(app, _this.workId);
            });
        }
        else {
            ajaxUtils_1.AjaxUtils.post("work/addToLibrary", { workId: this.workId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.libraryId(result.data);
                try {
                    metrikaUtils_1.default.reachGoal("addToLibrary", { workId: _this.workId });
                }
                catch (ex) { }
            })
                .always(function () {
                _this.processing(false);
                _this.handleRefreshWorkMetaInfo(app, _this.workId);
            });
        }
    };
    return AddToContactButtonComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-add-to-library-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AddToContactButtonComponent;
//# sourceMappingURL=mobileAddToLibraryButton.js.map